import {
  LIST_ALERT_RULES_RESPONSE,
  SAVE_ALERT_RULE_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// alertRuleId -> {alertRule}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_ALERT_RULES_RESPONSE: {
      const s = { ...state }
      const rules = action.rules || []
      rules.forEach((r) => {
        s[r.id] = r
      })
      return s
    }
    case SAVE_ALERT_RULE_RESPONSE: {
      return {
        ...state,
        [action.rule.id]: action.rule,
      }
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
